export default __webpack_public_path__ + "static/media/exclamation_point_blue.7cf5ad38.svg";